module.exports = "/images/yahoo.png?f3fb55f4d7eb8080584d60c2eb2e516b";